import { Map3dLayerView } from "./map.layer.view";
export class ElevationLayerView extends Map3dLayerView {
    constructor(map, layer, display, source) {
        super(map, layer, display, source);
        this._map = map;
    }
}
//# sourceMappingURL=map.layer.dem.js.map